import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden bg-motor-black" data-id="element-78">
      <div className="absolute inset-0 metal-texture opacity-30" data-id="element-79"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16 flex flex-col items-center text-center space-y-6" data-id="element-80">
        <motion.h1 initial={{
        opacity: 0,
        y: -20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7
      }} className="font-bebas text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-none text-white uppercase tracking-wide" data-id="element-81">
          SACÁLE EL MÁXIMO RENDIMIENTO A TU{' '}
          <span className="text-motor-red" data-id="element-82">MOTOR 2T</span>{' '}
          <span className="text-motor-red" data-id="element-83">EN MENOS DE 48H</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.85
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="relative w-full flex justify-center" data-id="element-84">
          <div className="absolute inset-0 bg-gradient-to-br from-motor-red/20 to-transparent rounded-lg blur-3xl" data-id="element-85"></div>
          <img src="https://cdn.magicpatterns.com/uploads/8TT21JKDiMMTjBFqEdhGGg/Moto_2t_pro.png" alt="Motor 2T Pro - Guía completa para dominar tu motor 2 tiempos" className="relative w-full max-w-md mx-auto drop-shadow-[0_0_40px_rgba(225,6,0,0.4)]" data-id="element-86" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="text-lg sm:text-xl text-gray-300 font-montserrat font-medium max-w-2xl mx-auto" data-id="element-87">
          Más potencia, menos fallas y sin gastar de más en mecánicos
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.7
      }} data-id="element-88">
          <motion.button whileHover={{
          scale: 1.05,
          boxShadow: '0 0 40px rgba(225, 6, 0, 0.6)'
        }} whileTap={{
          scale: 0.95
        }} className="bg-motor-red text-white font-bebas text-2xl sm:text-3xl px-12 py-5 rounded-none uppercase tracking-wider shadow-red-glow hover:bg-red-700 transition-all duration-300 flex items-center gap-3 group" data-id="element-89">
            ACCEDER AHORA
            <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-90" />
          </motion.button>
        </motion.div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-motor-black to-transparent" data-id="element-91"></div>
    </section>;
}